import * as React from 'react';
import {ReactSVG} from "react-svg";
import hstatic, {staticHypotheekbondUrl} from "@dnhb/content-api-client/src/util/hstatic";
import {Widget} from "../Content";
import {ColumnContainer} from "../Containers";
import {LAYOUT_CONSTANTS} from "../../const";
import {useEffect, useState} from "react";

const {FORM_ROW_PADDING} = LAYOUT_CONSTANTS;

const SearchWidget: React.FC = ({
  children,
  ...props
}) => {
  const [icon, setIcon] = useState<string>('search');
  const [title, setTitle] = useState<string>('Zoek in alle berichten');

  useEffect(() => {
    if (children === 'subscribe') {
      setIcon('mail');
      setTitle('Schrijf je in op de nieuwsbrief');
    } else if (children === 'contact') {
      setIcon('advisor');
      setTitle('Neem contact met mij op');
    }
  }, [children]);

  return (
    <Widget {...props}>
      <ColumnContainer
        style={{
          padding: FORM_ROW_PADDING,
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <h4
          className={"f-5 fw-600"}
          style={{
            textAlign: 'center',
          }}
        >
          {title}
        </h4>

        <span
          className={"theme--primary-font-color"}
          style={{
            padding: `${FORM_ROW_PADDING} 0`,
            width: 'inherit',
            maxWidth: '48px'
          }}
        >
          <ReactSVG
            src={hstatic(`${staticHypotheekbondUrl()}images/icon/${icon}.svg`)}
          />
        </span>

        <span
          className={"f-7 fw-600"}
          style={{
            textAlign: 'center'
          }}
        >
          Binnenkort...
        </span>
      </ColumnContainer>
    </Widget>
  );
}

export default SearchWidget;
